module.exports = __webpack_public_path__ + "static/media/oct24-5.12dc995e.png";